import React, { useState, useEffect } from 'react';
import styles from './Dashboard.module.scss'; // Import the CSS Module
import { dashBoardPipelineApi } from 'src/api/CaseApi';
import RoutingUtil from 'src/utils/RoutingUtil';
import { useHistory } from 'react-router';

const Render = (props) => {
  const { results, handleRouting } = props;
  const {
    carLoanThisMonth,
    carLoanPrevMonth,
    carLoanThisWeek,
    carLoanPrevWeek,
    carLoanToday,
    insuranceThisMonth,
    insurancePrevMonth,
    insuranceThisWeek,
    insurancePrevWeek,
    insuranceToday,
    last2MonthsInsurance,
    last2MonthsCarLoan,
    last3MonthsInsurance,
    last3MonthsCarLoan,
    casesExpiringTodayStage,
  } = results;

  return (
    <div className={styles['dashboard-container']}>
      <h2>AutoNet Marketing</h2>
      <p>Welcomes You..</p>
      <div className={styles.row}>
        {/* Car Loan Card */}
        <div className={styles.card}>
          <h4>Car Loan</h4>
          <ul className="list-unstyled">
            <li>Car Loan:</li>
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleRouting('CAR_LOAN', 'today');
                }}
              >
                Today <span className={styles.count}>{carLoanToday?.[0]?.totalLoanAmount || 0}</span>
              </a>
            </li>
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleRouting('CAR_LOAN', 'thisWeek');
                }}
              >
                This Week <span className={styles.count}>{carLoanThisWeek?.[0]?.totalLoanAmount || 0}</span>
              </a>
            </li>
            {/* <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleRouting('CAR_LOAN', 'prevWeek');
                }}
              >
                Prev Week <span className={styles.count}>{carLoanPrevWeek?.[0]?.totalLoanAmount || 0}</span>
              </a>
            </li> */}
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleRouting('CAR_LOAN', 'thisMonth');
                }}
              >
                This Month <span className={styles.count}>{carLoanThisMonth?.[0]?.totalLoanAmount || 0}</span>
              </a>
            </li>
            {/* <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleRouting('CAR_LOAN', 'prevMonth');
                }}
              >
                Prev Month <span className={styles.count}>{carLoanPrevMonth?.[0]?.totalLoanAmount || 0}</span>
              </a>
            </li> */}
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleRouting('CAR_LOAN', 'last2Months');
                }}
              >
                Last Two Months <span className={styles.count}>{last2MonthsCarLoan?.[0]?.totalLoanAmount || 0}</span>
              </a>
            </li>
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleRouting('CAR_LOAN', 'last3Months');
                }}
              >
                Last Three Months <span className={styles.count}>{last3MonthsCarLoan?.[0]?.totalLoanAmount || 0}</span>
              </a>
            </li>
          </ul>
        </div>

        {/* Insurance Card */}
        <div className={styles.card}>
          <h4>Insurance</h4>
          <ul className="list-unstyled">
            <li>Insurance:</li>
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleRouting('VEHICLE_INSURANCE', 'today');
                }}
              >
                Today <span className={styles.count}>{insuranceToday?.[0]?.totalPolicyPremium || 0}</span>
              </a>
            </li>
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleRouting('VEHICLE_INSURANCE', 'thisWeek');
                }}
              >
                This Week <span className={styles.count}>{insuranceThisWeek?.[0]?.totalPolicyPremium || 0}</span>
              </a>
            </li>
            {/* <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleRouting('VEHICLE_INSURANCE', 'prevWeek');
                }}
              >
                Prev Week <span className={styles.count}>{insurancePrevWeek?.[0]?.totalPolicyPremium || 0}</span>
              </a>
            </li> */}
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleRouting('VEHICLE_INSURANCE', 'thisMonth');
                }}
              >
                This Month <span className={styles.count}>{insuranceThisMonth?.[0]?.totalPolicyPremium || 0}</span>
              </a>
            </li>
            {/* <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleRouting('VEHICLE_INSURANCE', 'prevMonth');
                }}
              >
                Prev Month <span className={styles.count}>{insurancePrevMonth?.[0]?.totalPolicyPremium || 0}</span>
              </a>
            </li> */}
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleRouting('VEHICLE_INSURANCE', 'last2Months');
                }}
              >
                Last Two Months <span className={styles.count}>{last2MonthsInsurance?.[0]?.totalPolicyPremium || 0}</span>
              </a>
            </li>
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleRouting('VEHICLE_INSURANCE', 'last3Months');
                }}
              >
                Last Three Months <span className={styles.count}>{last3MonthsInsurance?.[0]?.totalPolicyPremium || 0}</span>
              </a>
            </li>
          </ul>
        </div>

        {/* Others MIS Card */}
        <div className={styles.card}>
          <h4>Others MIS</h4>
          <ul className="list-unstyled">
            <li>Other Report:</li>
            <li>
              <span>Insurance Expiry Today</span>
              <span className={styles.count}>{casesExpiringTodayStage?.[0]?.count || 0}</span>
            </li>
          </ul>
        </div>
      </div>
      <footer className={styles.footer}>
        <p>&copy; 2024 - AutoNet ERP</p>
        <p className={styles['powered-by']}>Powered by:</p>
      </footer>
    </div>
  );
};

const DashBoard = () => {
  const history = useHistory();
  const [results, setResults] = useState({});

  useEffect(() => {
    const callApi = async () => {
      let {
        data: { data: [pipeResult] },
      } = await dashBoardPipelineApi();
      setResults(pipeResult);
    };

    callApi();
  }, []);

  const getDateRange = (period) => {
    const today = new Date();
    switch (period) {
      case 'thisWeek': {
        const startOfWeek = new Date(today);
        startOfWeek.setDate(today.getDate() - today.getDay() + 1); // Monday
        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 6);
        return { CaseFromDate: startOfWeek, CaseToDate: endOfWeek };
      }
      case 'prevWeek': {
        const startOfPrevWeek = new Date(today);
        startOfPrevWeek.setDate(today.getDate() - today.getDay() - 6); // Previous Monday
        const endOfPrevWeek = new Date(startOfPrevWeek);
        endOfPrevWeek.setDate(startOfPrevWeek.getDate() + 6);
        return { CaseFromDate: startOfPrevWeek, CaseToDate: endOfPrevWeek };
      }
      case 'thisMonth': {
        const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        return { CaseFromDate: startOfMonth, CaseToDate: endOfMonth };
      }
      case 'prevMonth': {
        const startOfPrevMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const endOfPrevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
        return { CaseFromDate: startOfPrevMonth, CaseToDate: endOfPrevMonth };
      }
      case 'last2Months': {
        const startOfLast2Months = new Date(today.getFullYear(), today.getMonth() - 2, 1);
        const endOfLast2Months = new Date(today.getFullYear(), today.getMonth(), 0);
        return { CaseFromDate: startOfLast2Months, CaseToDate: endOfLast2Months };
      }
      case 'last3Months': {
        const startOfLast3Months = new Date(today.getFullYear(), today.getMonth() - 3, 1);
        const endOfLast3Months = new Date(today.getFullYear(), today.getMonth(), 0);
        return { CaseFromDate: startOfLast3Months, CaseToDate: endOfLast3Months };
      }
      case 'today': {
        return { CaseFromDate: today, CaseToDate: today };
      }
      default:
        return null;
    }
  };

  const handleRouting = (productCategory, rangeType) => {
    const range = getDateRange(rangeType);
    const filters = { productCategory, ...range };
    history.push({
      pathname: RoutingUtil.salesReportSearch(),
      state: { filters },
    });
  };

  return <Render results={results} handleRouting={handleRouting} />;
};

export default DashBoard;
